import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * Catch-all for unmatched routes.
 *
 * Without this, react-router matched nothing and the routed area rendered an
 * empty <div className="container" />, so a mistyped or stale URL (a bookmark
 * to a screen that has since been renamed) produced a blank page under the nav
 * bar with no explanation — indistinguishable from a broken app.
 */
const NotFound: React.FC = () => {
  const location = useLocation();

  return (
    <div className="card" role="alert" style={{ maxWidth: '640px', margin: '48px auto' }}>
      <h2 style={{ marginTop: 0, fontFamily: 'var(--font-display)', color: 'var(--text-primary)' }}>
        Page not found
      </h2>
      <p style={{ color: 'var(--text-secondary)' }}>
        There’s nothing at{' '}
        <code
          style={{
            padding: '2px 6px',
            background: 'var(--bg-input)',
            border: '1px solid var(--border-subtle)',
            borderRadius: 'var(--radius-sm)',
            wordBreak: 'break-all',
          }}
        >
          {location.pathname}
        </code>
        . The link may be out of date, or the address may have a typo.
      </p>
      <div style={{ display: 'flex', gap: '10px', marginTop: '20px', flexWrap: 'wrap' }}>
        <Link className="btn btn-primary" to="/board">
          Go to the board
        </Link>
        <Link className="btn btn-secondary" to="/">
          Go to the home page
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
